// extracted by mini-css-extract-plugin
export default {"article":"Article_article__R0RV1","link":"Article_link__Z+KUO","actions":"Article_actions__m0fhN","action":"Article_action__JnPK9","tags":"Article_tags__3acQ2"};